import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Barlow\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-barlow\"}],\"variableName\":\"barlow\"}");
;
import(/* webpackMode: "eager", webpackExports: ["UseProvider"] */ "/home/vsts/work/1/s/src/app/contexts/UsuarioContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppInsightsProvider"] */ "/home/vsts/work/1/s/src/components/AppInsightsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/home/vsts/work/1/s/src/components/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/home/vsts/work/1/s/src/components/ErrorBoundary.tsx");
